import React, { createContext, useContext, useState } from 'react';
import eventEmitter, { EVENT_TYPES } from './ContextEvents';

const ClientsContext = createContext();

export const useClients = () => {
  const context = useContext(ClientsContext);
  if (!context) {
    throw new Error('useClients must be used within a ClientsProvider');
  }
  return context;
};

export const ClientsProvider = ({ children }) => {
  // Initialize clients from localStorage or use default values
  const [clients, setClients] = useState(() => {
    const savedClients = localStorage.getItem('facit_clients');
    return savedClients ? JSON.parse(savedClients) : [
      {
        id: 1,
        clientNumber: '01',
        type: 'company',
        name: 'SARL TechnoAlger',
        contactPerson: 'Ahmed Belkacem',
        email: 'contact@technoalger.dz',
        phone: '+213 21 456 789',
        address: '15 Rue Didouche Mourad, Alger',
        city: 'Alger',
        postalCode: '16000',
        registrationNumber: 'RC 16/001234',
        taxNumber: 'NIF 098765432109',
        fiscalId: '163190104418159',
        article: '1901022407',
        rc: '19/00-0433048A99',
        contactPhone: '036 62 60 08',
        category: 'Technologie',
        status: 'active',
        createdDate: '2023-06-15',
        lastOrder: '2024-01-15',
        totalOrders: 12,
        totalAmount: 2850000
      },
      {
        id: 2,
        clientNumber: '02',
        type: 'individual',
        name: 'Dr. Fatima Benali',
        contactPerson: 'Dr. Fatima Benali',
        email: 'f.benali@clinique.dz',
        phone: '+213 31 234 567',
        address: '45 Boulevard 1er Novembre, Oran',
        city: 'Oran',
        postalCode: '31000',
        registrationNumber: '',
        taxNumber: '',
        fiscalId: '163190105522840',
        article: '1901032815',
        rc: '31/00-1234567B88',
        contactPhone: '+213 31 234 567',
        category: 'Santé',
        status: 'active',
        createdDate: '2023-08-22',
        lastOrder: '2024-01-10',
        totalOrders: 5,
        totalAmount: 675000
      },
      {
        id: 3,
        clientNumber: '03',
        type: 'company',
        name: 'EURL InnovCorp',
        contactPerson: 'Karim Messaoudi',
        email: 'info@innovcorp.dz',
        phone: '+213 25 345 678',
        address: '78 Rue Ben Badis, Constantine',
        city: 'Constantine',
        postalCode: '25000',
        registrationNumber: 'RC 25/005678',
        taxNumber: 'NIF 123456789012',
        fiscalId: '163190106633951',
        article: '2501041203',
        rc: '25/00-7890123C77',
        contactPhone: '+213 25 345 678',
        category: 'Innovation',
        status: 'active',
        createdDate: '2023-09-10',
        lastOrder: '2024-01-08',
        totalOrders: 8,
        totalAmount: 1450000
      },
      {
        id: 4,
        clientNumber: '04',
        type: 'institution',
        name: 'Université d\'Alger',
        contactPerson: 'Prof. Amina Kaddour',
        email: 'formation@univ-alger.dz',
        phone: '+213 21 123 890',
        address: '2 Rue Didouche Mourad, Alger',
        city: 'Alger',
        postalCode: '16000',
        registrationNumber: 'Établissement Public',
        taxNumber: '',
        fiscalId: '163190107744062',
        article: '1605051408',
        rc: '16/00-5678901D66',
        contactPhone: '+213 21 123 890',
        category: 'Éducation',
        status: 'active',
        createdDate: '2023-05-30',
        lastOrder: '2024-01-12',
        totalOrders: 3,
        totalAmount: 225000
      },
      {
        id: 5,
        clientNumber: '05',
        type: 'company',
        name: 'SARL ConstructAlger',
        contactPerson: 'Omar Brahimi',
        email: 'contact@constructalger.dz',
        phone: '+213 21 567 890',
        address: '12 Avenue Pasteur, Alger',
        city: 'Alger',
        postalCode: '16030',
        registrationNumber: 'RC 16/009876',
        taxNumber: 'NIF 567890123456',
        fiscalId: '163190108855173',
        article: '1607052109',
        rc: '16/00-9876543E55',
        contactPhone: '+213 21 567 890',
        category: 'Construction',
        status: 'inactive',
        createdDate: '2023-04-18',
        lastOrder: '2023-11-20',
        totalOrders: 2,
        totalAmount: 890000
      },
      {
        id: 6,
        clientNumber: '06',
        type: 'company',
        name: 'EURL MediaPrint',
        contactPerson: 'Samira Boudjemaa',
        email: 'contact@mediaprint.dz',
        phone: '+213 21 345 678',
        address: '33 Rue Didouche Mourad, Alger',
        city: 'Alger',
        postalCode: '16000',
        registrationNumber: 'RC 16/007890',
        taxNumber: 'NIF 789012345678',
        fiscalId: '163190109966284',
        article: '1608062010',
        rc: '16/00-7890123F44',
        contactPhone: '+213 21 345 678',
        category: 'Impression',
        status: 'active',
        createdDate: '2023-10-15',
        lastOrder: '2024-01-05',
        totalOrders: 6,
        totalAmount: 420000
      },
      {
        id: 7,
        clientNumber: '07',
        type: 'individual',
        name: 'Maître Sofiane Tebboune',
        contactPerson: 'Maître Sofiane Tebboune',
        email: 's.tebboune@avocat.dz',
        phone: '+213 21 234 567',
        address: '18 Rue Ben Badis, Alger',
        city: 'Alger',
        postalCode: '16000',
        registrationNumber: 'Ordre des Avocats',
        taxNumber: '',
        fiscalId: '163190110077395',
        article: '1609072111',
        rc: '16/00-1234567G33',
        contactPhone: '+213 21 234 567',
        category: 'Juridique',
        status: 'active',
        createdDate: '2023-11-20',
        lastOrder: '2024-01-03',
        totalOrders: 4,
        totalAmount: 180000
      }
    ];
  });

  // Initialize suppliers from localStorage or use default values
  const [suppliers, setSuppliers] = useState(() => {
    const savedSuppliers = localStorage.getItem('facit_suppliers');
    return savedSuppliers ? JSON.parse(savedSuppliers) : [
      {
        id: 1,
        type: 'company',
        name: 'SARL TechDistrib',
        contactPerson: 'Yacine Benaissa',
        email: 'contact@techdistrib.dz',
        phone: '+213 21 789 456',
        address: '25 Rue Mohamed Belouizdad, Alger',
        city: 'Alger',
        postalCode: '16000',
        registrationNumber: 'RC 16/002345',
        taxNumber: 'NIF 234567890123',
        fiscalId: '163190108855173',
        article: '1607052109',
        rc: '16/00-2345678E55',
        contactPhone: '+213 21 789 456',
        category: 'Technologie',
        status: 'active',
        createdDate: '2023-07-20',
        lastOrder: '2024-01-18',
        totalOrders: 15,
        totalAmount: 3200000,
        specialties: ['Matériel informatique', 'Logiciels'],
        paymentTerms: '30 jours',
        deliveryTime: '5-7 jours'
      },
      {
        id: 2,
        type: 'company',
        name: 'EURL FournituresPro',
        contactPerson: 'Amina Cherif',
        email: 'commandes@fournitures-pro.dz',
        phone: '+213 31 567 890',
        address: '12 Avenue de l\'ALN, Oran',
        city: 'Oran',
        postalCode: '31000',
        registrationNumber: 'RC 31/003456',
        taxNumber: 'NIF 345678901234',
        fiscalId: '163190109966284',
        article: '3108061510',
        rc: '31/00-3456789F44',
        contactPhone: '+213 31 567 890',
        category: 'Fournitures',
        status: 'active',
        createdDate: '2023-08-15',
        lastOrder: '2024-01-20',
        totalOrders: 22,
        totalAmount: 1850000,
        specialties: ['Fournitures bureau', 'Papeterie'],
        paymentTerms: '15 jours',
        deliveryTime: '2-3 jours'
      },
      {
        id: 3,
        type: 'company',
        name: 'SNC EquipementPlus',
        contactPerson: 'Rachid Hamidi',
        email: 'ventes@equipement-plus.dz',
        phone: '+213 25 234 567',
        address: '45 Rue Larbi Ben Mhidi, Constantine',
        city: 'Constantine',
        postalCode: '25000',
        registrationNumber: 'RC 25/004567',
        taxNumber: 'NIF 456789012345',
        fiscalId: '163190110077395',
        article: '2509071811',
        rc: '25/00-4567890G33',
        contactPhone: '+213 25 234 567',
        category: 'Équipements',
        status: 'active',
        createdDate: '2023-09-05',
        lastOrder: '2024-01-15',
        totalOrders: 8,
        totalAmount: 2750000,
        specialties: ['Équipements industriels', 'Outillage'],
        paymentTerms: '45 jours',
        deliveryTime: '7-10 jours'
      }
    ];
  });

  const addClient = (client) => {
    const newClient = {
      id: clients.length + 1,
      clientNumber: (clients.length + 1).toString().padStart(2, '0'),
      createdDate: new Date().toISOString().split('T')[0],
      lastOrder: '',
      totalOrders: 0,
      totalAmount: 0,
      status: 'active',
      ...client
    };
    
    const updatedClients = [...clients, newClient];
    setClients(updatedClients);
    
    // Save to localStorage for persistence
    localStorage.setItem('facit_clients', JSON.stringify(updatedClients));
    
    // Emit events
    eventEmitter.emit(EVENT_TYPES.CLIENT_CREATED, newClient);
    eventEmitter.emit(EVENT_TYPES.DATA_CHANGED, 'clients');
    
    return newClient;
  };

  const updateClient = (id, updatedClient) => {
    const oldClient = clients.find(client => client.id === id);
    const newClients = clients.map(client => 
      client.id === id ? { ...client, ...updatedClient } : client
    );
    
    setClients(newClients);
    
    // Save to localStorage for persistence
    localStorage.setItem('facit_clients', JSON.stringify(newClients));
    
    // Emit events
    eventEmitter.emit(EVENT_TYPES.CLIENT_UPDATED, {
      oldClient,
      newClient: newClients.find(client => client.id === id)
    });
    eventEmitter.emit(EVENT_TYPES.DATA_CHANGED, 'clients');
  };

  const deleteClient = (id) => {
    const clientToDelete = clients.find(client => client.id === id);
    const newClients = clients.filter(client => client.id !== id);
    setClients(newClients);
    
    // Save to localStorage for persistence
    localStorage.setItem('facit_clients', JSON.stringify(newClients));
    
    // Emit events
    eventEmitter.emit(EVENT_TYPES.CLIENT_DELETED, clientToDelete);
    eventEmitter.emit(EVENT_TYPES.DATA_CHANGED, 'clients');
  };

  const addSupplier = (supplier) => {
    const newSupplier = {
      id: suppliers.length + 1,
      supplierNumber: (suppliers.length + 1).toString().padStart(2, '0'),
      createdDate: new Date().toISOString().split('T')[0],
      status: 'active',
      ...supplier
    };
    
    const updatedSuppliers = [...suppliers, newSupplier];
    setSuppliers(updatedSuppliers);
    
    // Save to localStorage for persistence
    localStorage.setItem('facit_suppliers', JSON.stringify(updatedSuppliers));
    
    // Emit events
    eventEmitter.emit(EVENT_TYPES.DATA_CHANGED, 'suppliers');
    
    return newSupplier;
  };

  const updateSupplier = (id, updatedSupplier) => {
    const newSuppliers = suppliers.map(supplier => 
      supplier.id === id ? { ...supplier, ...updatedSupplier } : supplier
    );
    
    setSuppliers(newSuppliers);
    
    // Save to localStorage for persistence
    localStorage.setItem('facit_suppliers', JSON.stringify(newSuppliers));
    
    // Emit events
    eventEmitter.emit(EVENT_TYPES.DATA_CHANGED, 'suppliers');
  };

  const deleteSupplier = (id) => {
    const newSuppliers = suppliers.filter(supplier => supplier.id !== id);
    setSuppliers(newSuppliers);
    
    // Save to localStorage for persistence
    localStorage.setItem('facit_suppliers', JSON.stringify(newSuppliers));
    
    // Emit events
    eventEmitter.emit(EVENT_TYPES.DATA_CHANGED, 'suppliers');
  };

  const getAllPartners = () => {
    return [...clients, ...suppliers];
  };

  const getActiveClients = () => {
    return clients.filter(client => client.status === 'active');
  };

  const getActiveSuppliers = () => {
    return suppliers.filter(supplier => supplier.status === 'active');
  };

  const value = {
    clients,
    suppliers,
    addClient,
    updateClient,
    deleteClient,
    addSupplier,
    updateSupplier,
    deleteSupplier,
    getAllPartners,
    getActiveClients,
    getActiveSuppliers,
    setClients,
    setSuppliers
  };

  return (
    <ClientsContext.Provider value={value}>
      {children}
    </ClientsContext.Provider>
  );
}; 